var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.112 18V11.832H0.24V10.296H2.112V8.328H0.24V6.792H2.112V0.863999H4.608L6.888 6.792H9.72V0.863999H11.616V6.792H13.488V8.328H11.616V10.296H13.488V11.832H11.616V18H9.096L6.816 11.832H3.984V18H2.112ZM3.984 10.296H6.24L5.52 8.328H3.936L3.984 10.296ZM9.72 14.616H9.816L9.744 11.832H8.736L9.72 14.616ZM3.936 6.792H4.944L3.936 3.816H3.84L3.936 6.792ZM8.16 10.296H9.768L9.72 8.328H7.44L8.16 10.296Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.3e349e14d2da736e6eb4a02beef192d2.svg";
export { ForwardRef as ReactComponent };